'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'wifi';
var width = 576;
var height = 512;
var aliases = ["wifi-3","wifi-strong"];
var unicode = 'f1eb';
var svgPathData = 'M40.9 181.4C104.4 118.7 191.7 80 288.1 80s183.6 38.7 247.2 101.4c9.4 9.3 24.6 9.2 33.9-.2s9.2-24.6-.2-33.9C496.8 76 397.5 32 288.1 32S79.3 76 7.1 147.3c-9.4 9.3-9.5 24.5-.2 33.9s24.5 9.5 33.9 .2zM288.1 256c53.6 0 101.6 23.9 133.9 61.7 8.6 10.1 23.8 11.3 33.8 2.7s11.3-23.8 2.7-33.8c-41-48-102.2-78.6-170.4-78.6s-129.3 30.5-170.4 78.6c-8.6 10.1-7.4 25.2 2.7 33.8s25.2 7.4 33.8-2.7c32.3-37.8 80.3-61.7 133.9-61.7zm48 176a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faWifi = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;